import styled from '@emotion/styled';
import { bodyB } from '@teamsparta/stack-font';
import { vars } from '@teamsparta/stack-tokens';

import { DESKTOP } from '@/styles/themes';

export const Background = styled.div`
  z-index: 19;
  position: fixed;
  width: 100%;
  bottom: 0;
  transition: all 0.2s ease 0s;
  padding: 0 16px 20px 16px;

  ${DESKTOP} {
    background: none;
    backdrop-filter: none;
    box-shadow: none;
    padding-bottom: 12px;
  }
`;

export const Wrapper = styled.div`
  border-radius: 10px;
  background: rgba(58, 62, 65, 0.8);
  backdrop-filter: blur(5px);

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;

  padding: 10px 10px 10px 14px;
  width: 328px;

  height: 63px;
  margin: 0 auto;

  ${DESKTOP} {
    width: 500px;
    padding: 10px 10px 10px 20px;
  }
`;

export const Cta = styled.div`
  ${bodyB};
  color: ${vars.neutral[0]} !important;

  min-width: 42px;
  height: auto;
  padding: 10px 20px;
  border-radius: 8px;
  background: ${vars.brand.default};

  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  white-space: nowrap;
`;

export const MobileText = styled.div`
  ${bodyB};
  color: ${vars.neutral[0]};
  word-break: keep-all;
  ${DESKTOP} {
    display: none;
  }
`;

export const DesktopText = styled.div`
  display: none;
  ${DESKTOP} {
    display: block;
    color: ${vars.neutral[0]};
    ${bodyB};
    word-break: keep-all;
    br {
      display: none;
    }
  }
`;
